$ = require 'jquery'
Storage = require 'app/scripts/lib/storage'
TrelloModel = require 'app/scripts/models/internal/trello-model'
_ = require 'underscore'

module.exports = class LocalStorageModel extends TrelloModel
  constructor: ->
    super
    @_onStorageLocalBound = this._onStorage.bind(this)
    Storage.listen(@_onStorageLocalBound)

  destructor: ->
    @disableTabSync()
    Storage.unlisten(@_onStorageLocalBound)

  # call enableTabSync to update one tab when local storage is updated in another
  enableTabSync: ->
    @_onRemoteStorageBound = (e) => this._onStorage(e.originalEvent)
    $(window).on 'storage', @_onRemoteStorageBound

  disableTabSync: ->
    if @_onRemoteStorageBound?
      $(window).off 'storage', @_onRemoteStorageBound

  default: ->
    {}

  _onStorage: (storageData) ->
    if storageData?.key == @id && storageData.oldValue != storageData.newValue
      # We don't want to do a full fetch, because that will reset the keys
      # that aren't synced to localStorage
      @set(this.syncedKeysFromLocalStorage())
      @onStorage?(storageData)

  sync: (method, model, options) ->
    { success } = options
    switch method
      when 'create'
        ### jshint -W027 ###
        throw Error("not implemented")
      when 'read'
        json = model.syncedKeysFromLocalStorage()
        _.defaults(json, @default())
        success?(model, json, options)
      when 'update'
        json = model.toJSON()
        defaultValues = @default()

        delete json.id
        for key, value of json
          if _.isEqual(value, defaultValues[key])
            delete json[key]

        if _.isEmpty(json)
          Storage.unset(model.id)
        else
          Storage.set(model.id, json)
        success?(model, model.toJSON(), options)
      when 'delete'
        Storage.unset(model.id)
        success?(model, null, options)

  syncedKeysFromLocalStorage: ->
    json = Storage.get(@id) ? {}
    return _.pick(json, @syncedKeys)

  syncedKeys: -> true

  toJSON: -> _.pick(@attributes, @syncedKeys)

  _persistUpdate: (params, next) ->
    Storage.set(@id, _.extend(Storage.get(@id) ? @default(), params))
    next?(null, @toJSON())

  toggle: (attr, value) ->
    if @inSet(attr, value)
      @pull(attr, value)
      false
    else
      @addToSet(attr, value)
      true

  inSet: (attr, value) ->
    value in (@get(attr) ? [])

  addToSet: (attr, value) ->
    @save(attr, (@get(attr) ? []).concat(value))

  pull: (attr, value) ->
    @save(attr, _.without((@get(attr) ? []), value))
